/**
 * Sık gelen aynı işi tek uçuşa birleştirir (DEV-3899).
 *
 * İmzacı görev listesini hem `updateToken` sonrasında hem tarayıcının `updateTasks`
 * yayınında hem de döngünün aynası olarak çeker; bir devir patlaması art arda birkaç
 * GET /api/v1/task demekti. Ancak yeni görev tespiti (updateTasks'ın içindeki anında
 * tetikleme) gecikmemeli: ilk çağrı HEMEN çalışır (leading). Çalışırken ya da aranın
 * (araMs) içinde gelen tüm çağrılar TEK bir sondan (trailing) çalışmaya birleşir ve aynı
 * promise'i paylaşır; trailing tur, süren tur bitince ve son başlangıçtan araMs geçince
 * başlar. Bir turun hatası sonraki turu bozmaz.
 *
 * Saf tutuldu: saat ve zamanlayıcı enjekte edilebilir.
 */
export interface BirlestiriciSecenekleri {
    simdi?: () => number;
    zamanla?: (is: () => void, ms: number) => unknown;
}

export function tekUcusluBirlestir(
    calistir: () => Promise<unknown>,
    araMs: number = 2000,
    secenekler: BirlestiriciSecenekleri = {}
): () => Promise<void> {
    const simdi = secenekler.simdi ?? (() => Date.now());
    const zamanla = secenekler.zamanla ?? ((is: () => void, ms: number) => setTimeout(is, ms));

    let calisiyor = false;
    let sonBaslangic: number | null = null;
    let zamanlayiciKuruldu = false;
    let bekleyen: {
        promise: Promise<void>,
        coz: () => void,
        reddet: (e: unknown) => void
    } | null = null;

    function turuBaslat(): Promise<void> {
        calisiyor = true;
        sonBaslangic = simdi();
        let p: Promise<void>;
        try {
            p = Promise.resolve(calistir()).then(() => undefined);
        } catch (e) {
            p = Promise.reject(e);
        }
        const bitti = () => {
            calisiyor = false;
            planla();
        };
        p.then(bitti, bitti);
        return p;
    }

    function planla(): void {
        if (bekleyen === null || calisiyor || zamanlayiciKuruldu || sonBaslangic === null) {
            return;
        }
        const kalan = Math.max(0, sonBaslangic + araMs - simdi());
        zamanlayiciKuruldu = true;
        zamanla(() => {
            zamanlayiciKuruldu = false;
            const b = bekleyen;
            bekleyen = null;
            if (b === null) {
                return;
            }
            turuBaslat().then(b.coz, b.reddet);
        }, kalan);
    }

    return () => {
        if (bekleyen !== null) {
            return bekleyen.promise;
        }
        if (!calisiyor && (sonBaslangic === null || simdi() - sonBaslangic >= araMs)) {
            return turuBaslat();
        }
        let coz: () => void = () => undefined;
        let reddet: (e: unknown) => void = () => undefined;
        const promise = new Promise<void>((res, rej) => {
            coz = res;
            reddet = rej;
        });
        bekleyen = {promise, coz, reddet};
        planla();
        return promise;
    };
}
